const MEDICAL_DOODLE_TILE = `
<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200">
  <g fill="none" stroke="#6d5fae" stroke-opacity="0.1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    <path d="M20 15h10v8h8v10h-8v8H20v-8h-8V23h8z"/>
    <path d="M70 25h14l5-11 7 22 5-10h15"/>
    <g transform="rotate(30 168 28)">
      <rect x="153" y="22" width="30" height="12" rx="6"/>
      <path d="M168 22v12"/>
    </g>
    <circle cx="60" cy="58" r="3"/>
    <path d="M138 55h10l4-8 5 15 4-7h9"/>
    <path d="M30 84c-6-7-16-1-11 7 3 5 11 10 11 10s8-5 11-10c5-8-5-14-11-7z"/>
    <circle cx="100" cy="88" r="7"/>
    <path d="M95 83l10 10"/>
    <path d="M164 84h8v6h6v8h-6v6h-8v-6h-6v-8h6z"/>
    <path d="M55 125h9M59.5 120.5v9"/>
    <circle cx="140" cy="130" r="3"/>
    <path d="M20 148v8c0 7 5 13 13 13s13-6 13-13v-8"/>
    <circle cx="46" cy="174" r="5"/>
    <g transform="rotate(-24 102 162)">
      <rect x="84" y="155" width="36" height="14" rx="7"/>
      <path d="M97 158v8M102 158v8M107 158v8"/>
    </g>
    <path d="M158 178l18-18M180 156l5 5M162 182l-6-6M168 168l3 3M164 172l3 3"/>
  </g>
</svg>`;

/**
 * Inline style for chat message areas. Applied via `style` because the
 * pattern is a data-URI SVG that can't be expressed as a Tailwind class.
 */
export const chatSurfaceStyle = {
  backgroundColor: "#f7f5fb",
  backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(MEDICAL_DOODLE_TILE)}")`,
  backgroundSize: "200px 200px",
};

/** Container classes that pair with chatSurfaceStyle. */
export const chatSurfaceClasses =
  "rounded-lg border border-purple-100/80 shadow-inner";
